import { motion } from "framer-motion";

const TiltCard = ({ children }) => {
  return (
    <motion.div
      whileHover={{
        rotateX: 6,
        rotateY: -6,
        scale: 1.03,
      }}
      transition={{ type: "spring", stiffness: 200 }}
      style={{ transformStyle: "preserve-3d" }}
    >
      {children}
    </motion.div>
  );
};

export default TiltCard;